import apiClient from '../../shared/services/apiClient';

// Admin-only anti-abuse API (/api/admin/abuse/*, /api/admin/users/linked|ban-linked).
const unwrap = async (p) => {
    try {
        const r = await p;
        return r.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

const abuseService = {
    getSettings: () => unwrap(apiClient.get('/api/admin/abuse/settings')),
    saveSettings: (settings) => unwrap(apiClient.post('/api/admin/abuse/settings', { settings })),
    getHits: (params = {}) => unwrap(apiClient.get('/api/admin/abuse/hits', { params })),
    getLinked: (userId) => unwrap(apiClient.get('/api/admin/users/linked', { params: { id: userId } })),
    banLinked: (userId, userIds) => unwrap(apiClient.post('/api/admin/users/ban-linked', { id: userId, user_ids: userIds })),
};

export default abuseService;
